
export default function EmptySection() {
  return (
    <section className="py-24 bg-[#0F0F0F]">
      <div className="max-w-[1400px] mx-auto px-8">
        {/* 빈 섹션 */}
      </div>
    </section>
  );
}
